<template>
  <div class="boxplot-cotainer-box">
    <div class="boxploy-item-box" v-for="(item, index) in optionArr" :key="index">
      <v-chart :options="item.barOption" :autoresize="true"></v-chart>
    </div>
  </div>
</template>

<script>
import { statChart } from '@/echartOption/stat';

export default {
  components: {},
  props: {
    optionData: {
      type: Array
    }
  },
  data() {
    return {
      optionArr: []
    };
  },
  watch: {
    optionData: {
      handler(newVal) {
        this.packageData(newVal);
      },
      deep: true,
      immediate: true
    }
  },
  computed: {},
  methods: {
    packageData(val) {
      val.forEach(item => {
        let { dataList, dimensions } = item;
        item.barOption = statChart({
          color: ['#4992ff'],
          grid: {
            containLabel: true,
            left: '6%',
            right: '10%',
            bottom: '15%'
          },
          title: [
            {
              text: item.sn,
              right: '5%',
              textStyle: {
                color: '#04c5d5',
                fontSize: 20
              }
            }
          ],
          tooltip: {
            axisPointer: {
              type: 'shadow'
            },
            trigger: 'item'
          },
          dataZoom: [{ type: 'inside' }],
          xAxis: {
            type: 'category',
            data: dimensions,
            nameGap: 30,
            axisLine: {
              lineStyle: {
                color: '#04c5d5'
              }
            },
            boundaryGap: true
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: { color: '#fff', opacity: 0.2 }
              // lineStyle: {
              //   color: '#00eeff'
              // }
            }
            // axisLine: {
            //   lineStyle: {
            //     color: '#00eeff'
            //   }
            // }
          },
          series: [
            {
              type: 'boxplot',
              data: dataList
            }
          ]
        });
      });

      this.optionArr = val;
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.boxplot-cotainer-box {
  height: 100%;
  .boxploy-item-box {
    width: 100%;
    height: 500px;
  }
}
</style>
